import { Component, Input, input, ChangeDetectionStrategy } from "@angular/core";
import { NgClass } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
	selector: "stages-navigation-entry-change-marker",
	templateUrl: "./change-marker-navigation-entry.component.html",
	styleUrls: ["./change-marker-navigation-entry.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslateModule, NgClass],
})
export class ChangeMarkerNavigationEntryComponent {
	// TODO: Skipped for migration because:
	//  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
	//  and migrating would break narrowing currently.
	@Input()
	entry!: ChangeMarkerEntry;

	readonly mode = input<NAV_ENTRY_DISPLAY_MODE>();

	get originalHasChangeMarker(): boolean {
		const original = this.entry.original;
		return (
			original.changeMarker &&
			(original.changeMarker.subelements > 0 ||
				original.changeMarker.changed ||
				original.changeMarker.added ||
				original.changeMarker.deleted)
		);
	}
}
